import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Message } from 'src/app/messages/interfaces/Message';
import { MessageViewComponent } from '../../message-view-popup/message-view.component';
import { MessagesFacade } from 'src/app/messages/_services/messages.facade';
import { TranslateService } from '@ngx-translate/core';
import 'moment-timezone';
import * as moment from 'moment';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
@Component({
  selector: 'app-messages-compact-view',
  templateUrl: './messages-compact-view.component.html',
  styleUrls: ['./messages-compact-view.component.scss']
})
export class MessagesCompactViewComponent implements OnInit, OnChanges {
  tableControls: any = { data: [] };
  @Input() messagesList: Message[];
  @Input() paginatorInfo: any;
  @Input() isLoading: boolean = false;
  @Output() onPaginationBtnClick = new EventEmitter();
  @Output() onSortingTable = new EventEmitter();

  messages: Message[] = [];

  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    public messagesFacade: MessagesFacade,
    private timeZoneService:TimeZoneService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.messagesList) {
      if (changes.messagesList.currentValue != changes.messagesList.previousValue) {
        this.messages = changes.messagesList.currentValue;
        this.setTableData();
      }
    }
  }

  ngOnInit(): void {
    this.setTableData()
  }

  paginationHandler(value) {
    this.onPaginationBtnClick.emit(value)
  }

  setTableData() {
    const messages = this.messages.map((message: any) => {
      let timeFormat = new Date(message.updated_at);
      // const time = timeFormat.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
      // const time =moment(timeFormat).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').format('hh:mm A')
      const time = this.timeZoneService.convertToLocalTime(timeFormat , 'YYYY-MM-DD HH:mm:ss' , 'hh:mm A')

      return (
        {

          title: message.title,
          recepientsNo: message.users.length,
          views: message.number_of_views,
          date: message.updated_at?.split(' ')[0],
          time: time,
          id: message.id,
          content: message.content,
          type: message.type,
          priority: message.priority,
          attachments: message.attachments,
          recipients: message.users
        }
      )
    })
    this.translate.onLangChange.subscribe(param => {
      this.tableData(messages)
    })
    this.translate.get('init').subscribe(param => {
      this.tableData(messages)
    })
  }
  tableData(msg) {
    this.tableControls = {
      selection: false,
      paging: true,
      view: 'compact',
      columns: [
        {
          name: this.translate.instant('messages.messages'),
          sort: false,
          type: "string",
          source: "title"
        },
        {
          name: this.translate.instant('messages.recipients'),
          sort: false,
          type: "string",
          source: "recepientsNo"
        },
        {
          name: this.translate.instant('messages.views'),
          sort: false,
          type: "string",
          source: "views"
        },
        {
          name: this.translate.instant('messages.time'),
          sort: true,
          type: "string",
          source: "time"
        },
        {
          name: this.translate.instant('messages.date'),
          sort: true,
          type: "string",
          source: "date"
        },
        //  {
        //   name: "Status",
        //   sort: false,
        //   type: "string",
        //   source: "parent_address"
        // }
      ],
      data: msg
    }
  }
  tableEventHandeler(event) {
    switch (event.action) {
      case 'rowClicked':
        this.messagesFacade.setMessageById(event.target.data.id);
        const dialogRef = this.dialog.open(MessageViewComponent, {
          width: '90vw',
          data: event.target.data,
          disableClose: true
        });
        break;

      case 'sorting':
        this.onSortingTable.emit(event.target.order);
        break;
    }

  }
}
